<template>
  <v-app>
    <!-- 側邊欄 -->
    <AppSidebar v-if="showSidebar" />

    <!-- 主內容 -->
    <v-main class="main-content">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AppSidebar from "@/components/AppSidebar.vue";

export default {
  components: { AppSidebar },
  computed: {
    // 根據路由判斷是否顯示側邊欄
    showSidebar() {
      return this.$route.path !== "/login";
    },
  },
};
</script>

<style scoped>
/* 主內容區背景色 */
.main-content {
  background-color: #f5f5f5; /* 與側邊欄背景一致 */
}
</style>
